function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M84.43 36.31c-2.79-6.24-11.08-19.54-31.41-20.52-22.29-1.08-37.01 16.48-31.35 36.87.91 3.27 3.91 12.49 10.78 15.97 4.77 2.42 7.21-1.01 8.81-2.67 1.94-2.03 4.94-10.88 7.52-12.49 2.49-1.57 5.26-1.38 10.28-.76 3.67.46 6.85.47 9.23-3.16 4.04-6.16 7.87-9.48 13.96-10.02 1.05-.1 3.05-1.29 2.18-3.22z",
  fill: "#4dbfd9"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M80.53 37.77s-5.98-22.43-32.61-23.71c-22.29-1.08-37.01 16.48-31.35 36.87.91 3.27 3.91 12.49 10.78 15.97 4.77 2.42 7.21-1.01 8.81-2.67 1.94-2.03 4.94-10.88 7.52-12.49 2.49-1.57 5.26-1.38 10.28-.76 3.67.46 6.85.47 9.23-3.16 4.73-7.24 9.18-10.56 17.34-10.05z",
  fill: "none",
  stroke: "#1e1e1c",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M39.82 21.93c2.37-.67 11.5-3.02 21.57 2.95",
  fill: "none",
  stroke: "#1e1e1c",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10
});

var _ref4 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 30.67,
  cy: 60.91,
  r: 1.52,
  fill: "#1e1e1c"
});

var _ref5 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 57.13,
  cy: 44.91,
  r: 1.52,
  fill: "#1e1e1c"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M58.96 55.01c.57 2.95.71 8.6-.52 13.9m-20.9 0c1.24 1.48 7.28 4.77 14.2 5.47",
  fill: "none",
  stroke: "#1e1e1c",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10
});

var _ref7 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 55.2,
  cy: 74.23,
  r: 3.46,
  fill: "none",
  stroke: "#1e1e1c",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  d: "M55.2 78.15c.18 2.35 0 7.84 0 7.84",
  fill: "none",
  stroke: "#1e1e1c",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 100 100"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
};

export default __webpack_public_path__ + "static/media/helmet.f34c8716.svg";
export { SvgComponent as ReactComponent };